import React, { useState, useEffect } from 'react';
import { useAuthContext } from '../../hooks/useAuthContext';
import "./AlertsSettings.css";
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import firebase from '../../Firebase';

if (!getApps().length) {
  initializeApp(firebase);
}

const Alerts = ({ isChecked: propIsChecked, onCheckboxChange }) => {
  const { user } = useAuthContext();
  const auth = getAuth();
  // Local state fallback if parent doesn't control the state
  const [localIsChecked, setLocalIsChecked] = useState(propIsChecked || false);

  // Determine which state to use
  const isControlled = propIsChecked !== undefined;
  const checkedValue = isControlled ? propIsChecked : localIsChecked;

  useEffect(() => {
    if (!user || !user.userId) return;
    
    auth.currentUser.getIdToken().then(token => {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/usersettings/get/${user.userId}`, {
        headers: {'Authorization': `Bearer ${token}`}
      })
      .then(response => response.json())
      .then(data => {
        const initialValue = data.interconnectionAlerts;
        if (isControlled && typeof onCheckboxChange === 'function') {
          onCheckboxChange(initialValue);
        } else {
          setLocalIsChecked(initialValue);
        }
      })
      .catch(console.error);
    });
  }, [user, isControlled, onCheckboxChange]);

  const handleCheckboxChange = (event) => {
    const newValue = event.target.checked;
    
    // Update parent if callback exists
    if (typeof onCheckboxChange === 'function') {
      onCheckboxChange(newValue);
    } 
    // Update local state if not controlled
    else if (!isControlled) {
      setLocalIsChecked(newValue);
    }

    // Always update backend
    auth.currentUser.getIdToken().then(token => {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/usersettings/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }, 
        body: JSON.stringify({
          userId: user.userId,
          interconnectionAlerts: newValue,
        }),
      }).catch(console.error);
    });
  };

  return (
    <div className="alert-container">
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5em', marginBottom: '1em' }}>
        <h2 id="alert-heading" style={{ margin: 0 }}>
          Confirm you are happy to be contacted by email:
        </h2>
      </div>
      <div key="contactConsent" className="alert-field">
        <div id="checkbox-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '0.2em', marginTop: '0.2em' }}>
          <label htmlFor="contactConsent" className="alert-label">
            I confirm
          </label>
          <input
            type="checkbox"
            id="contactConsent"
            name="contactConsent"
            checked={checkedValue}
            onChange={handleCheckboxChange}
            className="alert-input"
          />
        </div>
      </div>
    </div>
  );
};

export default Alerts;


// import React, { useEffect } from 'react';
// import { useAuthContext } from '../../hooks/useAuthContext';
// import "./AlertsSettings.css";
// import { initializeApp, getApps } from 'firebase/app';
// import { getAuth } from 'firebase/auth';
// import firebase from '../../Firebase';
// import InfoPopup from '../InfoPopup';

// if (!getApps().length) {
//   initializeApp(firebase);
// }

// const Alerts = ({ isChecked, onCheckboxChange }) => {
//   const { user } = useAuthContext();
//   const auth = getAuth();


//   useEffect(() => {
//     if (!user || !user.userId) return;
//     auth.currentUser.getIdToken().then(token => {
//       fetch(`http://localhost:4000/api/usersettings/get/${user.userId}`, {
//         headers: {'Authorization': `Bearer ${token}`}
//       })
//       .then(response => response.json())
//       .then(data => {
//         onCheckboxChange(data.interconnectionAlerts);
//       })
//       .catch(error => console.error('Error:', error));
//     });
//   }, [user, onCheckboxChange]);

//   const handleCheckboxChange = (event) => {
//     const newValue = event.target.checked;
//     onCheckboxChange(newValue);
//     auth.currentUser.getIdToken().then(token => {
//       fetch('http://localhost:4000/api/usersettings/update', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         }, 
//         body: JSON.stringify({
//           userId: user.userId,
//           interconnectionAlerts: newValue,
//         }),
//       })
//       .then(response => response.json())
//       .then(data => console.log("API response:", data))
//       .catch(error => console.error('Error:', error));
//     });
//   };

//   return (
//     <div className="alert-container">
//       <div style={{ display: 'flex', alignItems: 'center', gap: '0.5em', marginBottom: '1em' }}>
//         <h2 id="alert-heading" style={{ margin: 0 }}>
//           Confirm you are happy to be contacted by email:
//         </h2>
//         {/* <InfoPopup
//           infoText={
//             <ul style={{ margin: 0, paddingLeft: '1.2em', color: 'var(--text-light)', fontSize: '1em', lineHeight: 1.6 }}>
//               <li>You'll only be contacted about people to connect with and people you've chosen to connect with.</li>
//               <li>Your personal email address won't be shared with other members.</li>
//               <li>You can turn off at anytime.</li>
//             </ul>
//           }
//         /> */}
//       </div>
//       <div key="contactConsent" className="alert-field">
//         <div id="checkbox-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '0.2em', marginTop: '0.2em' }}>
//           <label htmlFor="contactConsent" className="alert-label">
//             I confirm
//           </label>
//           <input
//             type="checkbox"
//             id="contactConsent"
//             name="contactConsent"
//             checked={isChecked}
//             onChange={handleCheckboxChange}
//             className="alert-input"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Alerts;
